import baseInitState from 'src/helpers/redux/baseInitState'
import baseReducer from 'src/helpers/redux/baseReducer'

import { actionType } from './listDaftarPembelian.action'

const initState = {
  ...baseInitState,
}

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actionType('action').request:
      return {
        ...state,
        isLoadingSubmit: true,
      }
    case actionType('action').success:
      return {
        ...state,
        isLoadingSubmit: false,
      }
    case actionType('action').error:
      return {
        ...state,
        isLoadingSubmit: false,
      }
    case actionType('exportFile').request:
      return {
        ...state,
        isLoadingExport: true,
      }
    case actionType('exportFile').success:
      return {
        ...state,
        isLoadingExport: false,
      }
    case actionType('exportFile').error:
      return {
        ...state,
        isLoadingExport: false,
      }
    default:
      return baseReducer(state, action, actionType)
  }
}
